import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Brain, Moon, HeartPulse, Shield, Users, Sparkles } from 'lucide-react';
const benefits = [{
  icon: Brain,
  title: 'Dejá de sobrepensar',
  description: 'Tu mente va a dejar de dar vueltas en loop sin control.'
}, {
  icon: Moon,
  title: 'Dormí mejor cada noche',
  description: 'Técnicas reales para calmar tu mente antes de dormir.'
}, {
  icon: HeartPulse,
  title: 'Bajá los síntomas físicos',
  description: 'Pecho apretado, nudo en la garganta, tensión... se van.'
}, {
  icon: Shield,
  title: 'Regulá tus emociones',
  description: 'Dejá de reaccionar desde el miedo y la impulsividad.'
}, {
  icon: Users,
  title: 'Sentí seguridad en tus relaciones',
  description: 'Sin dependencia, sin miedo al abandono.'
}, {
  icon: Sparkles,
  title: 'Recuperá claridad mental',
  description: 'Pensá con calma, decidí con confianza.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function BenefitsSection() {
  return <section className="py-24 bg-beige-light" data-id="element-16">
      <div className="max-w-6xl mx-auto px-6" data-id="element-17">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-19">
            ¿Qué vas a lograr con este sistema?
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-20"></div>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-21">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm border border-beige-dark/50 hover:shadow-md transition-shadow duration-300" data-id="element-22">
              <div className="w-12 h-12 bg-beige rounded-xl flex items-center justify-center mb-6 text-navy" data-id="element-23">
                <benefit.icon size={24} strokeWidth={1.5} data-id="element-24" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-3" data-id="element-25">
                {benefit.title}
              </h3>
              <p className="text-slate leading-relaxed" data-id="element-26">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}